var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportAccuracy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_5554_12422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.6667 112.001C72.44 112.001 93.3333 91.1079 93.3333 65.3346C93.3333 39.5613 72.44 18.668 46.6667 18.668C20.8934 18.668 0 39.5613 0 65.3346C0 91.1079 20.8934 112.001 46.6667 112.001Z",
    fill: "#FFD25D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M46.6667 19.8346C72.1467 19.8346 92.82 40.5173 93.2867 66.2026C93.296 65.9133 93.3333 65.6286 93.3333 65.3346C93.3333 39.5606 72.4407 18.668 46.6667 18.668C20.8927 18.668 0 39.5606 0 65.3346C0 65.6286 0.0373333 65.9133 0.0466667 66.2026C0.513333 40.5173 21.1867 19.8346 46.6667 19.8346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.1,
    d: "M46.6667 110.833C21.1867 110.833 0.513333 90.1502 0.0466667 64.4648C0.0373333 64.7542 0 65.0388 0 65.3328C0 91.1068 20.8927 112 46.6667 112C72.4407 112 93.3333 91.1068 93.3333 65.3328C93.3333 65.0388 93.296 64.7542 93.2867 64.4648C92.82 90.1502 72.1467 110.833 46.6667 110.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.6667 98.0013C64.708 98.0013 79.3333 83.3759 79.3333 65.3346C79.3333 47.2933 64.708 32.668 46.6667 32.668C28.6254 32.668 14 47.2933 14 65.3346C14 83.3759 28.6254 98.0013 46.6667 98.0013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.6667 84.0013C56.976 84.0013 65.3333 75.6439 65.3333 65.3346C65.3333 55.0253 56.976 46.668 46.6667 46.668C36.3574 46.668 28 55.0253 28 65.3346C28 75.6439 36.3574 84.0013 46.6667 84.0013Z",
    fill: "#FFD25D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M46.6667 70.0013C49.244 70.0013 51.3333 67.912 51.3333 65.3346C51.3333 62.7573 49.244 60.668 46.6667 60.668C44.0893 60.668 42 62.7573 42 65.3346C42 67.912 44.0893 70.0013 46.6667 70.0013Z",
    fill: "url(#paint0_radial_5554_12422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.8636 54.4411C59.2522 54.4411 58.6658 54.1982 58.2335 53.7659C57.8012 53.3335 57.5583 52.7472 57.5583 52.1358V51.4824C57.2306 51.5932 56.9323 51.7766 56.6856 52.0191C56.6856 52.0191 45.8963 64.5631 46.6663 65.3331C47.4363 66.1031 59.985 55.3184 59.985 55.3184C60.2263 55.07 60.4082 54.77 60.517 54.4411H59.8636Z",
    fill: "#D1CEC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M111.785 20.019C111.626 19.6726 111.383 19.3707 111.08 19.1396C110.777 18.9086 110.421 18.7555 110.045 18.6936C105.714 17.9843 98.9053 16.2716 97.3187 14.6803C95.732 13.089 94.0147 6.2803 93.3053 1.9543C93.2439 1.57722 93.0908 1.221 92.8596 0.91691C92.6283 0.612821 92.3259 0.370174 91.9789 0.210279C91.6319 0.0503847 91.251 -0.0218653 90.8696 -0.0001249C90.4882 0.0216155 90.1179 0.136681 89.7913 0.334966C89.3667 0.591632 79.3333 6.76563 79.3333 16.3323V24.569C68.488 33.5616 56 44.8223 56 48.999V53.6656C56 54.2845 56.2458 54.878 56.6834 55.3156C57.121 55.7531 57.7145 55.999 58.3333 55.999H63C67.1767 55.999 78.4373 43.511 87.43 32.6656H95.6667C105.233 32.6656 111.407 22.6323 111.664 22.203C111.86 21.8771 111.974 21.5082 111.995 21.1284C112.016 20.7485 111.944 20.3646 111.785 20.019Z",
    fill: "#D1CEC6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.1,
    d: "M58.23 53.7695L46.666 65.3335C47.436 66.1035 59.9847 55.3189 59.9847 55.3189C60.2261 55.0704 60.408 54.7704 60.5167 54.4415H59.8633C59.5602 54.4429 59.2598 54.3842 58.9795 54.2689C58.6991 54.1535 58.4444 53.9838 58.23 53.7695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M111.785 20.019C111.626 19.6726 111.383 19.3707 111.08 19.1396C110.777 18.9086 110.421 18.7555 110.045 18.6936C105.714 17.9843 98.9053 16.2716 97.3187 14.6803C95.732 13.089 94.0147 6.2803 93.3053 1.9543C93.2439 1.57722 93.0908 1.221 92.8596 0.91691C92.6283 0.612821 92.3259 0.370174 91.9789 0.210279C91.6319 0.0503847 91.251 -0.0218653 90.8696 -0.0001249C90.4882 0.0216155 90.1179 0.136681 89.7913 0.334966C89.3667 0.591632 79.3333 6.76563 79.3333 16.3323V24.569C68.488 33.5616 56 44.8223 56 48.999V53.6656C56 54.2845 56.2458 54.878 56.6834 55.3156C57.121 55.7531 57.7145 55.999 58.3333 55.999H63C67.1767 55.999 78.4373 43.511 87.43 32.6656H95.6667C105.233 32.6656 111.407 22.6323 111.664 22.203C111.86 21.8771 111.974 21.5082 111.995 21.1284C112.016 20.7485 111.944 20.3646 111.785 20.019Z",
    fill: "#66A6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.1,
    d: "M111.786 20.0203C111.626 19.674 111.384 19.372 111.08 19.141C110.777 18.9099 110.421 18.7568 110.045 18.695C105.714 17.9856 98.9056 16.273 97.319 14.6816L56.6816 55.319C57.1016 55.739 57.6896 56.0003 58.3336 56.0003H63.0003C67.177 56.0003 78.4376 43.5123 87.4303 32.667H95.667C105.234 32.667 111.408 22.6336 111.664 22.2043C111.861 21.8785 111.974 21.5095 111.996 21.1297C112.017 20.7499 111.945 20.3659 111.786 20.0203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.8767 55.1271H60.0967C60.05 55.1831 60.036 55.2625 59.9847 55.3138C59.9847 55.3138 47.4313 66.1031 46.666 65.3331L79.664 98.3311C84.0038 94.0026 87.4455 88.859 89.7912 83.1962C92.137 77.5333 93.3405 71.4626 93.3327 65.3331C93.336 55.1425 89.9783 45.2353 83.78 37.1465C75.8373 46.3632 67.372 55.1271 63.8767 55.1271Z",
    fill: "url(#paint1_linear_5554_12422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M111.785 20.019C111.626 19.6726 111.383 19.3707 111.08 19.1396C110.777 18.9086 110.421 18.7555 110.045 18.6936C105.714 17.9843 98.9053 16.2716 97.3187 14.6803C95.732 13.089 94.0147 6.2803 93.3053 1.9543C93.2439 1.57722 93.0908 1.221 92.8596 0.916909C92.6283 0.612821 92.3259 0.370174 91.9789 0.210279C91.6319 0.0503847 91.251 -0.0218653 90.8696 -0.0001249C90.4882 0.0216155 90.1179 0.136681 89.7913 0.334966C89.3667 0.591632 79.3333 6.76563 79.3333 16.3323V24.569C77.8867 25.7683 76.412 27.0096 74.9373 28.265C66.8287 22.038 56.8904 18.6635 46.6667 18.6656C20.8927 18.6656 0 39.5583 0 65.3323C0 91.1063 20.8927 111.999 46.6667 111.999C72.4407 111.999 93.3333 91.1063 93.3333 65.3323C93.3333 54.6923 89.7307 44.911 83.734 37.057C84.994 35.587 86.2307 34.1123 87.43 32.6656H95.6667C105.233 32.6656 111.407 22.6323 111.664 22.203C111.861 21.8766 111.975 21.5068 111.996 21.1261C112.018 20.7453 111.945 20.3652 111.785 20.019Z",
    fill: "url(#paint2_linear_5554_12422)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5554_12422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5253 65.554) scale(3.71933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#232F3E",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232F3E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5554_12422",
    x1: 62.99,
    y1: 49.0091,
    x2: 95.988,
    y2: 82.0071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5554_12422",
    x1: 11.018,
    y1: 31.3356,
    x2: 95.6247,
    y2: 70.7876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5554_12422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAccuracy);
export default __webpack_public_path__ + "static/media/report_accuracy.40cdbdc4427250079c7395e9bdd10b68.svg";
export { ForwardRef as ReactComponent };